import { render } from "./RecursiveClinicalTrialsMenu.vue?vue&type=template&id=688ddb44"
import script from "./RecursiveClinicalTrialsMenu.vue?vue&type=script&lang=js"
export * from "./RecursiveClinicalTrialsMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__